// extracted by mini-css-extract-plugin
export default {"root":"AdminLayout_root__HXUNf","main":"AdminLayout_main__hwFk7","mainChrome":"AdminLayout_mainChrome__c2rs9","mainScroll":"AdminLayout_mainScroll__pM+7p"};